import Markdoc, { Node, Config } from '@markdoc/markdoc';
import React from 'react';

import { ColoredText } from '@/keystatic/utils/markdocComponents/coloredTextMark';

type IRenderMarkdocProps = {
  node: Node | null;
  className?: string;
};

export const RenderMarkdoc = ({ node, className }: IRenderMarkdocProps) => {
  if (!node) {
    return null;
  }

  const baseConfig: Config = {
    tags: {
      coloredText: {
        render: 'ColoredText',
        attributes: {
          variant: { type: 'String', required: true },
        },
      },
    },
  };

  const errors = Markdoc.validate(node, baseConfig);
  if (errors.length) {
    return null;
  }

  const transformedNode = Markdoc.transform(node, baseConfig);

  const renderedContent = Markdoc.renderers.react(transformedNode, React, {
    components: {
      ColoredText: ColoredText,
    },
  });

  if (React.isValidElement(renderedContent)) {
    if (renderedContent.type === 'article') {
      const children = React.Children.map(
        renderedContent.props.children,
        child => {
          if (React.isValidElement(child)) {
            const newProps = {
              // eslint-disable-next-line
              ...((child.props || {}) as Record<string, any>),
              className,
            };
            return React.cloneElement(child, newProps);
          }
          return child;
        }
      );

      return <>{children}</>;
    }

    const newProps = {
      // eslint-disable-next-line
      ...((renderedContent.props || {}) as Record<string, any>),
      className,
    };

    return React.cloneElement(renderedContent, newProps);
  }

  return renderedContent;
};
